export default {
  // 列表查询
  GET_DATA_API: '/financial/payment/listFundPayableInvoiceByPage',
  // 发票详情
  GET_DETAIL_API: '/financial/payment/fundPayableInvoice',
  // 导出
  POST_LIST_EXPORT: '/financial/payment/exportFundPayableInvoices',
  // 币种查询
  LIST_CURRENCY: '/maindata/currency/listCurrency',
  // 汇率查询
  GET_CURRENCY_EXCHANGE: '/maindata/currencyExchange/listCurrencyExchangeByPage',
  // 字典表查询
  DICT_LIST: '/maindata/dictData/listDataDictByDataType',
  // 允差校验
  TOLERANCE_CHECK: '/financial/payment/toleranceCheck',
  // 创建发票
  CREATE_PAYABLE_INVOICE: '/financial/payment/saveFundPayableInvoice',
  // 提交发票
  SUBMIT_Invoice: '/financial/payment/submit',
  // 删除发票
  DELETE_INVOICE: '/financial/payment/delete',
  // 编辑发票
  EDIT_INVOICE: '/financial/payment/updateFundPayableInvoiceAndDetail',
  // 撤回
  WITHDRAW_INLIST_ORDER_BYPAGEVOICE: '/financial/payment/withdraw',
  // 退回
  RETURNED_INVOICE: '/financial/payment/returned',
  // 冲销
  REVERSE_INVOICE: '/financial/payment/reverse',
  // 采购合同
  LIST_ORDER_BYPAGE: '/sales/order/listOrderByPage',
  // 批量生成凭证
  GENERATE_CREDENTIALS: '/financial/payment/generateCredentials',
  // 生成凭证
  GENERATE_CREDENTIAL: '/financial/payment/generateCredential',
  // 销售提单列表
  LIST_STORAGE_LAGE_PAGE: '/warehouse/storageLade/listStorageLadePage',
  // 销售提单列表(包含行信息)
  LIST_STORAGE_LAGE_DETAIL_PAGE: '/warehouse/storageLade/queryStorageLadePickingPage',
  /** 结算批次-获取列表 */
  LIST_ORDER_SETTLE_BY_PAGE: '/sales/orderSettle/listOrderSettleOther',
  // 获取付款单的行号列表
  LIST_LINE_NUMBER_GET: '/financial/fundPayment/listLineNumberByPaymentNum',
  // 付款单号列表
  LIST_PAYMENT_NUM: '/financial/fundPayment/listPaymentNum',
  // 根据付款单号和行号查找付款信息
  GET_PAY_INFO: '/financial/fundPayment/getPaymentForInvoiceVO',
  // 发票信息增删改
  PAYABLE_INVOICE_PAYMENT_DETAIL: '/financial/payment/saveFundPayableInvoicePaymentDetail',
  // 发票付款信息列表
  PAYABLE_INVOICE_PAYMENT_LIST: '/financial/payment/listFundPayableInvoicePaymentDetail',
  // 匹配采购合同列表查询
  LIST_BUSINESS_INBOUNDS: '/warehouse/businessInbound/listBusinessInbounds',
  // 获取默认对账科目
  GET_PROCUREMENT_RECONCILATION_SUBJECT: '/maindata/partners/getProcurementReconciliationSubject',
  // 账套查询
  LIST_LEDGERS: '/maindata/ledger/listLedgers',
  // 账套查询
  GENERATE_PAYMENT_DOCUMENT: '/financial/paymentApply/createPaymentApplyForInvoiceId',
  // 采购退换货-列表查询
  LIST_PURCHERCASERETURN: '/sales/purchaseReturn/listPurchaseReturnByPage',
  //批量导入
  IMPORT: '/financial/payment/importFundPayableInvoice',
  //批量提交
  BATCH_SUBMIT: '/financial/payment/batchSubmit',
  //批量过帐
  BATCH_VOUCHER: '/financial/payment/batchSyncVoucher',
  //批量标记过帐
  BATCH_SIGN_VOUCHER: '/financial/payment/batchSignSyncVoucher',
  //确认
  DO_CONFIRM: '/financial/payment/doConfirm',
  // 更改结算批次
  UPDATE_SETTLE: '/financial/payment/updateSettlementOfBatch',
  // 导出匹配采购合同数据
  EXPORT_BUSINESS_INBOUNDS: '/financial/payment/exportBusinessInbounds',
  // 根据合同号生成采购发票
  CREATE_BY_CONTRACT: '/financial/payment/makeInvoiceBycontractNo',
  // 生成付款申请前校验
  CHECK_CREATE_PAYMENTAPPLY: '/financial/paymentApply/checkCreatePaymentApplyForInvoiceId',
  // 打印业务入库单
  BATCH_PRINTBUSINESSINBOUND: '/sales/financePayableInvoice/batchPrintBusinessInboud',
  // 打印发票
  EXPORT_PRINT: '/sales/financePayableInvoice/exportPrint',
  // 导出进项发票
  EXPORT_INPUT_INVOICE: '/financial/payment/export/incoming',
};
